import axios from 'axios';
import get from 'lodash/get';

const axiosClientFiles = axios.create({
  baseURL: '',
  headers: {
    // 'Content-Type': 'application/json',
    'Content-Type': 'multipart/form-data',
  },
});

// Request Interceptor
axiosClientFiles.interceptors.request.use(
  (config) => {
    const oidcUserData = sessionStorage.getItem(
      `oidc.user:${process.env.REACT_APP_OIDC_AUTHORIY}:${process.env.REACT_APP_OIDC_CLIENT_ID}`
    );
    const token = oidcUserData ? get(JSON.parse(oidcUserData), 'access_token', '') : '';
    config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response Interceptor
axiosClientFiles.interceptors.response.use(
  (response) => {
    // Do something with response data
    return response;
  },
  function (error) {
    // Do something with response error
    return Promise.reject(error);
  }
);

export default axiosClientFiles;
